import reportError from '../helpers/reportError';
import displayError from '../helpers/displayError';

export default abstract class AbstractBaseError extends Error {
	protected readonly shouldBeReported: boolean = true;
	protected readonly shouldBeRetried: boolean | null = null;

	isShouldBeReported(): boolean {
		return this.shouldBeReported;
	}

	isShouldBeRetried(): boolean {
		return this.shouldBeRetried ?? this.isShouldBeReported();
	}

	report() {
		reportError(this);
	}

	display() {
		displayError(this);
	}
}
